import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { OnboardingActivity } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useBranchOnboardingQuery = (customBranch?: number) => {
  const branchId = useBranchId();
  const branch = customBranch || branchId;
  const query = useQuery<OnboardingActivity[]>({
    queryKey: [branch, "onboarding"],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/activation/activities/${branch}`),
    select: (data) => Object.values(data),
    enabled: branch !== undefined,
  });
  return query;
};

export default useBranchOnboardingQuery;
